import { atom } from "jotai";
import { ModeDePaiement } from "./enums/mode-de-paiement.enum";
import { Pack } from "./interfaces/pack.interface";

// Navbar open ou closed
export const navbarAtom = atom(false);
// Formule choisie dans page S'abonner
export const packAtom = atom<Pack | null | undefined>(null);
// Mode de paiement
export const modeDePaiementAtom = atom<ModeDePaiement | "">("");
